// extracted by mini-css-extract-plugin
export default {"infocard":"info_infocard__63tvg","icon_left":"info_icon_left__2DIok","icon_right":"info_icon_right__ySSeL","outer_infocard":"info_outer_infocard__cDiOc"};